import { Chart, ChartDataPoint } from '@frontend/chart/types';

export const WAITING_DAYS_DONUT_LABEL = {
    LESS_THAN_ONE_DAY: '<1',
    ONE_TO_THREE_DAYS: '1-3',
    MORE_THAN_THREE_DAYS: '>3'
} as const;

export const WAITING_DAYS_DONUT_LABELS = [
    WAITING_DAYS_DONUT_LABEL.LESS_THAN_ONE_DAY,
    WAITING_DAYS_DONUT_LABEL.ONE_TO_THREE_DAYS,
    WAITING_DAYS_DONUT_LABEL.MORE_THAN_THREE_DAYS
] as const;

const binCountOf = (chart: Chart): number => Math.max(0, ...chart.series.map((series) => series.data.length));

const valueAtBin = (chart: Chart, index: number): number => {
    if (index < 0) {
        return 0;
    }

    return chart.series.reduce((sum, series) => sum + (series.data[index]?.value ?? 0), 0);
};

const sumBinsUntil = (chart: Chart, endIndexInclusive: number): number => {
    if (endIndexInclusive < 0) {
        return 0;
    }

    let total = 0;
    for (let index = 0; index <= endIndexInclusive; index += 1) {
        total += valueAtBin(chart, index);
    }

    return total;
};

export const toWaitingDaysDonutChart = (chart: Chart): Chart => {
    const lastIndex = binCountOf(chart) - 1;
    const points: ChartDataPoint[] = [
        { label: WAITING_DAYS_DONUT_LABEL.LESS_THAN_ONE_DAY, value: valueAtBin(chart, lastIndex) },
        { label: WAITING_DAYS_DONUT_LABEL.ONE_TO_THREE_DAYS, value: valueAtBin(chart, lastIndex - 1) + valueAtBin(chart, lastIndex - 2) },
        { label: WAITING_DAYS_DONUT_LABEL.MORE_THAN_THREE_DAYS, value: sumBinsUntil(chart, lastIndex - 3) }
    ];

    return {
        series: [
            {
                name: chart.series[0]?.name ?? null,
                data: points
            }
        ]
    };
};
